import { lighten } from 'polished';
import { Border } from './Border';
import { Colors } from './Colors';
import { Typography } from './Typography';
export const Forms = {
  field: {
    backgroundColor: Colors.white,
    backgroundColorFocus: Colors.white,
    border: `1px solid ${Border.color.default}`,
    borderColor: Border.color.default,
    borderColorFocus: Colors.heroine,
    borderColorHover: lighten(0.15, Colors.steel),
    borderRadius: Border.radius.default,
    borderWidth: '1px',
    minHeight: '41px',
    padding: '10px',
    placeholderColor: Colors.steel,
    spacing: '1em',
    typography: Typography.body,
  },
};
